import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import "./Vehicle.css";
import Vehicle1 from "../../../Image/vehicle/Vector.png";
import Vehicle2 from "../../../Image/vehicle/Vector (1).png";
import Vehicle3 from "../../../Image/vehicle/Vector (2).png";
import Vehicle4 from "../../../Image/vehicle/Vector (3).png";

const useStyles = makeStyles({
  serviceHeading: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "30px 0",
  },
  serviceImg: {
    margin: "0 auto",
  },
});

const Vehicle = () => {
  const classes = useStyles();
  const [activeColor, setActiveColor] = useState("vehicleCard1");
  return (
    <div>
      <Container>
        <div className="service">
          <Box className="side_title">
            <Typography variant="h2">
              Choose from range of transportation vehicle
            </Typography>
          </Box>
          <Grid container spacing={4}>
            <Grid item xs={12} lg={3} md={3}>
              <Box
                onClick={() => setActiveColor("vehicleCard1")}
                className={`vehicleCard ${
                  activeColor === "vehicleCard1"
                    ? "vehicleCardActive"
                    : "vehicleCard"
                }`}
              >
                <Box>
                  <Typography variant="h5">Freezer</Typography>
                </Box>
                <Box>
                  <img
                    alt="Remy Sharp"
                    src={Vehicle1}
                    className={classes.serviceImg}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Box
                onClick={() => setActiveColor("vehicleCard2")}
                className={`vehicleCard ${
                  activeColor === "vehicleCard2" ? "vehicleCardActive" : ""
                }`}
              >
                <Box>
                  <Typography variant="h5">Tanker </Typography>
                </Box>
                <Box>
                  <img
                    alt="Remy Sharp"
                    src={Vehicle2}
                    className={classes.serviceImg}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Box
                onClick={() => setActiveColor("vehicleCard3")}
                className={`vehicleCard ${
                  activeColor === "vehicleCard3" ? "vehicleCardActive" : ""
                }`}
              >
                <Box>
                  <Typography variant="h5">Tipper</Typography>
                </Box>
                <Box>
                  <img
                    alt="Remy Sharp"
                    src={Vehicle3}
                    className={classes.serviceImg}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Box
                onClick={() => setActiveColor("vehicleCard4")}
                className={`vehicleCard ${
                  activeColor === "vehicleCard4" ? "vehicleCardActive" : ""
                }`}
              >
                <Box>
                  <Typography variant="h5">Container </Typography>
                </Box>
                <Box>
                  <img
                    alt="Remy Sharp"
                    src={Vehicle4}
                    className={classes.serviceImg}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default Vehicle;
